import React from 'react';

import { DefaultOptionsInterface, GroupSelectOptionsInterface, GroupSelectSitesCells } from '@components/common';

import { get5GLabel } from '@utils/common';

import {
	TOnChangeSites,
} from '@components/common/GroupSelect/GroupSelect.types';

import { ETechnologiesLabels, ETechnologiesValues } from '@enums/common';

import {
	SEARCH_BY_SITE_OR_CELL_ID_PLACEHOLDER,
	SELECT_SITES_OR_CELLS_LABEL,
} from '@components/Kpi/Parameters/constants';

import '../Parameters.scss';

interface TechnologySelectorsProps {
	isOranVendor: boolean;
	defaultValueT_4G_FDD: DefaultOptionsInterface[];
	defaultValueT_4G_TDD: DefaultOptionsInterface[];
	defaultValueT_5G: DefaultOptionsInterface[];
	options4GFdd?: GroupSelectOptionsInterface[];
	options4GTdd?: GroupSelectOptionsInterface[];
	options5G?: GroupSelectOptionsInterface[];
	onChangeSitesT_4G_FDD: (...params: TOnChangeSites) => void;
	onChangeSitesT_4G_TDD: (...params: TOnChangeSites) => void;
	onChangeSitesT_5G: (...params: TOnChangeSites) => void;
}

const get5GTechnologyLabel = (isOranVendor: boolean) => {
	return isOranVendor ? 'node' : 'site';
};

export const TechnologySelectors: React.FC<TechnologySelectorsProps> = ({
	isOranVendor,
	defaultValueT_4G_FDD,
	defaultValueT_4G_TDD,
	defaultValueT_5G,
	options4GFdd,
	options4GTdd,
	options5G,
	onChangeSitesT_4G_FDD,
	onChangeSitesT_4G_TDD,
	onChangeSitesT_5G,
}) => {
	const modalTitle = `Select ${get5GTechnologyLabel(isOranVendor)}/cells with ${get5GLabel(isOranVendor)}`;

	return (
		<div className='f5gParametersTechnology'>
			<div className='f5gParametersBodyLabel f5gParametersBodyLabelRequired'>
				Technology
			</div>
			{!isOranVendor &&
				<>
					<GroupSelectSitesCells
						checkboxLabel={ETechnologiesLabels.T_4G_FDD}
						defaultOptions={defaultValueT_4G_FDD}
						isCheckboxTheme
						isInLine
						label={SELECT_SITES_OR_CELLS_LABEL}
						modalLabel={`${SELECT_SITES_OR_CELLS_LABEL} with \n4G FDD`}
						name={ETechnologiesValues.T_4G_FDD}
						onChange={onChangeSitesT_4G_FDD}
						options={options4GFdd}
						searchPlaceholder={SEARCH_BY_SITE_OR_CELL_ID_PLACEHOLDER}
						selectAllName='select-all-4G-FDD-sites'
						withVirtualization
					/>
					<GroupSelectSitesCells
						checkboxLabel={ETechnologiesLabels.T_4G_TDD}
						defaultOptions={defaultValueT_4G_TDD}
						isCheckboxTheme
						isInLine
						label={SELECT_SITES_OR_CELLS_LABEL}
						modalLabel={`${SELECT_SITES_OR_CELLS_LABEL} with \n4G TDD`}
						name={ETechnologiesValues.T_4G_TDD}
						onChange={onChangeSitesT_4G_TDD}
						options={options4GTdd}
						searchPlaceholder={SEARCH_BY_SITE_OR_CELL_ID_PLACEHOLDER}
						selectAllName='select-all-4G-TDD-sites'
						withVirtualization
					/>
				</>
			}
			<GroupSelectSitesCells
				checkboxLabel={ETechnologiesLabels.T_5G + (isOranVendor ? ' O-RAN' : '')}
				defaultOptions={defaultValueT_5G}
				gap='54px'
				isCheckboxTheme
				isInLine
				label={`Select ${get5GTechnologyLabel(isOranVendor)}s/cells`}
				modalLabel={modalTitle}
				name={ETechnologiesValues.T_5G}
				onChange={onChangeSitesT_5G}
				options={options5G}
				searchPlaceholder={`Search by ${get5GTechnologyLabel(isOranVendor)} ID/cell ID`}
				selectAllName='select-all-5G-sites'
				withVirtualization
			/>
		</div>
	);
};
